import React from 'react';
import styled from 'styled-components';
import Header from './header';

import facebook from '../images/fb.png';
import instagram from '../images/insta.png';
import { FC } from 'react';
import { Helmet } from 'react-helmet';

const Main = styled.main`
    display: grid;
    min-height: 100vh;
    margin: 0;
    grid-template-rows: 1fr auto;
`;
const Content = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
    @media only screen and (max-width: 768px) {
        padding: 0 20px;
    }
`;

const Footer = styled.footer`
    max-width: 1400px;
    margin: 30px auto;

    @media only screen and (max-width: 768px) {
        margin-top: 40px;
        text-align: center;
    }
`;

const Copyright = styled.p`
    margin: 0;
    text-align: center;
`;

const Authors = styled.span`
    @media only screen and (max-width: 768px) {
        display: block;
        margin-top: 10px;
    }
`;

const SocialMedia = styled.div`
    text-align: center;
    margin-top: 10px;
    @media only screen and (max-width: 768px) {
    }

    img {
        width: 32px;
        margin: 0 5px;
    }
`;
const Layout: FC = ({ children }) => {
    return (
        <Main>
            <Helmet>
                <html lang="en" />
            </Helmet>
            <Content>
                <Header />
                {children}
            </Content>
            <Footer>
                <Copyright>
                    Copyright (c) {new Date().getFullYear()} Greative.{' '}
                    <Authors>Greative is Alex Balaita & Ema Popescu.</Authors>
                </Copyright>
                <SocialMedia>
                    <a
                        rel="noreferrer"
                        href="https://www.facebook.com/WeAreGreative"
                        target="_blank"
                        aria-label="Facebook"
                    >
                        <img
                            src={facebook}
                            width="32"
                            height="32"
                            alt="Facebook icon"
                        />
                    </a>
                    <a
                        rel="noreferrer"
                        href="https://www.instagram.com/greativeus/"
                        target="_blank"
                        aria-label="Instagram"
                    >
                        <img
                            src={instagram}
                            width="32"
                            height="32"
                            alt="Instagram icon"
                        />
                    </a>
                </SocialMedia>
            </Footer>
        </Main>
    );
};

export default Layout;
